<template>
  <div>
    <Dialog
      :key="tableKey"
      :visible.sync="duplicateDialog1"
      :style="{ width: '100%', overflowY: 'auto' }"
      :header="'Duplicate ' + namePlural"
      :modal="true"
      class="p-fluid"
    >
      The following {{ namePlural }} seems to be a duplicates of the
      {{ name }} you are trying to save. Please confirm if you wish to still
      save this {{ name }}?

      <DataTable
        :value="list"
        :paginator="true"
        :dataKey="dataId"
        class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-opportunities"
        :rows="50"
        :rowHover="true"
        :selection.sync="selected"
        :loading="loading"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[25, 50, 100]"
        currentPageReportTemplate="{first} to {last} of {totalRecords} Enquiries"
      >
        <template #empty> No {{ namePlural }} found. </template>
        <template #loading>
          Loading {{ namePlural }} data. Please wait.
        </template>
        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
        <Column
          headerStyle="width: 4em"
          field="sim_name_rank"
          header="Sim. Desc %"
          :sortable="true"
        >
          <!-- :style="'color: ' + getColors(slotProps.data.rank) + ';'" -->
          <template #body="slotProps">
            <div>
              <Button
                :label="
                  slotProps.data.sim_name_rank
                    ? Math.round(slotProps.data.sim_name_rank * 100).toString()
                    : ''
                "
                :class="
                  'p-button-sm p-button-rounded p-button-' +
                    getColors(slotProps.data.sim_name_rank)
                "
              />
            </div>
          </template>
        </Column>
        <Column
          headerStyle="width: 4em"
          field="sim_addr_rank"
          header="Sim. Addr %"
          :sortable="true"
        >
          <!-- :style="'color: ' + getColors(slotProps.data.rank) + ';'" -->
          <template #body="slotProps">
            <div>
              <Button
                :label="
                  slotProps.data.sim_addr_rank
                    ? Math.round(slotProps.data.sim_addr_rank * 100).toString()
                    : ''
                "
                :class="
                  'p-button-sm p-button-rounded p-button-' +
                    getColors(slotProps.data.sim_addr_rank)
                "
              />
            </div>
          </template>
        </Column>
        <Column
          field="custCode"
          header="Account No."
          :sortable="true"
          headerStyle="width: 100px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.custCode }}
          </template>
        </Column>
        <Column
          field="custName"
          header="Customer Name"
          :sortable="true"
          headerStyle="width: 200px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.custName }}
          </template>
        </Column>
        <Column
          field="address1"
          header="House"
          :sortable="true"
          headerStyle="width: 100px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.address1 }}
          </template>
        </Column>
        <Column
          field="address2"
          header="Street"
          :sortable="true"
          headerStyle="width: 100px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.address2 }}
          </template>
        </Column>
        <Column
          field="address3"
          header="Sub Area"
          :sortable="true"
          headerStyle="width: 100px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.address3 }}
          </template>
        </Column>
        <Column
          field="address4"
          header="City/Town"
          :sortable="true"
          headerStyle="width: 100px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.address4 }}
          </template>
        </Column>
        <Column
          field="postCode"
          header="Postcode"
          :sortable="true"
          headerStyle="width: 100px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.postCode }}
          </template>
        </Column>
        <Column
          field="regionName"
          header="Region"
          :sortable="true"
          headerStyle="width: 200px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.regionName }}
          </template>
        </Column>
        <Column
          field="mainBranchCode"
          header="Main Branch"
          :sortable="true"
          headerStyle="width: 100px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.mainBranchCode }}
          </template>
        </Column>
        <Column
          field="mainSalesExecName"
          header="Sales Exec"
          :sortable="true"
          headerStyle="width: 200px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.mainSalesExecName }}
          </template>
        </Column>
        <Column
          field="keyContactName"
          header="Main Contact"
          :sortable="true"
          headerStyle="width: 200px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.keyContactName }}
          </template>
        </Column>
        <Column
          field="dateCreated"
          header="Date Created"
          :sortable="true"
          headerStyle="width: 150px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.dateCreated }}
          </template>
        </Column>
        <Column
          field="createdBy"
          header="Created By"
          :sortable="true"
          headerStyle="width: 200px;"
        >
          <template #body="slotProps">
            {{ slotProps.data.createdBy }}
          </template>
        </Column>
      </DataTable>

      <template #footer>
        <Button
          style="float: left;"
          @click="showSelected()"
          label="Show details"
        />
        <Button
          v-if="selected && selected.length === 1"
          style="float: left;"
          @click="$emit('selected-customer', selected[0])"
          label="Select customer"
        />
        <Button
          v-if="disabledArr.includes('buttons')"
          @click="$emit('close')"
          label="Okay"
        />
        <Button
          v-if="!disabledArr.includes('buttons')"
          @click="$emit('close')"
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
        />
        <div v-if="!disabledArr.includes('buttons')" style="display: inline;">
          <ProgressSpinner
            v-if="requesting"
            style="width:25px; height:25px; width: 100px;"
            strokeWidth="5"
            fill="#EEEEEE"
            animationDuration=".5s"
          />
          <Button
            v-else
            @click="$emit('agree')"
            label="Save"
            icon="pi pi-check"
            autofocus
          />
        </div>
      </template>
    </Dialog>

    <duplicateDialog
      :name="name"
      :namePlural="namePlural"
      :duplicateDialog="displayDuplicateMessage"
      :duplicates="duplicates"
      @close="displayDuplicateMessage = false"
    />
  </div>
</template>

<script>
import duplicateDialog from "../duplicate/duplicateDialog";

export default {
  components: {
    duplicateDialog
  },
  props: {
    duplicateDialog: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    namePlural: {
      type: String,
      required: false
    },
    dataId: {
      type: String,
      required: true
    },
    disabledArr: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    requesting: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    displayDuplicateMessage: false,
    selected: [],
    duplicates: [],
    tableKey: 0
  }),
  computed: {
    duplicateDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.duplicateDialog;
      }
    },
    loading() {
      return this.list ? false : true;
    }
  },
  watch: {
    duplicateDialog(val) {
      this.tableKey++;
    },
    list(val) {
      this.tableKey++;
    }
  },
  methods: {
    showDetails(data) {
      this.$refs.filters2.toggle(event);
    },
    showSelected() {
      if (!(this.selected && this.selected.length)) {
        this.$toast.add({
          severity: "warn",
          summary: "Warning",
          detail: "Please select some " + this.namePlural,
          life: 5000
        });
      } else {
        this.displayDuplicateMessage = true;
        this.duplicates = this.selected;
      }
    },
    getColors(data) {
      let rank = data * 100;
      if (rank) {
        if (rank < 40) {
          return "secondary";
          // return 'Grey'
        } else if (rank >= 40 && rank < 55) {
          return "info";
          // return 'Blue'
        } else if (rank >= 55 && rank < 70) {
          return "help";
          // return 'Yellow'
        } else if (rank >= 70 && rank < 85) {
          return "warning";
          // return 'Orange'
        } else if (rank >= 90 && rank <= 100) {
          return "danger";
          // return 'Red'
        } else {
          return "danger";
          // return 'Black'
        }
      }
    }
  }
};
</script>

<style>
.label {
  color: black;
}

.data {
  color: blue;
}
</style>
